import { Column } from "components/Table/Table";
import { ClientRefsAddress } from "generated/graphql";

export type ClientRefAddressRow = Pick<
  ClientRefsAddress,
  "_id" | "firstname" | "lastname" | "email" | "address" | "phone_number"
>;

export const useClientRefAddressColumns = (text: any): Column<ClientRefAddressRow>[] => {
  return [
    {
      title: text.all.contact_name,
      field: "lastname",
      render: ({ lastname, firstname }) => `${firstname} ${lastname}`,
    },
    {
      title: text.all.email,
      field: "email",
    },
    {
      title: text.all.phone_number,
      field: "phone_number",
    },
    {
      title: text.all.address,
      field: "address",
      render: ({ address }) => `${address.address}`,
    },
  ];
};

export const useAddressActions = (text: any) => {
  const actions = [
    {
      key: "edit",
      label: text.all.edit,
    },
    {
      key: "delete",
      label: text.all.delete,
    },
  ];

  return actions;
};
